export const environment = {
  production: false,
  settings: {
    clientId: 'nessy.support.sales.client',
    authAuthority: 'https://nessy-id-demo.nessy.com'
  },
  api: {
    hub: 'https://hub-api-demo.nessy.com',
    id: 'https://nessy-id-demo.nessy.com/api/'
  },
  identity: {
    ghostUrl: 'https://nessy-id-demo.nessy.com/support/ghostlogin'
  },
  wordpress: {
    account: 'https://nessyshop.wpengine.com/<locale>/wp-admin/user-edit.php?user_id=<wordpress_id>',
    orders: 'https://nessyshop.wpengine.com/<locale>/wp-admin/post.php?post=<order-id>&action=edit'
  }
};
